'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _ExtensibleError2 = require('./ExtensibleError');
var _ExtensibleError3 = _interopRequireDefault(_ExtensibleError2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ResponseError = function (_ExtensibleError) {
  (0, _inherits3.default)(ResponseError, _ExtensibleError);
  function ResponseError() {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ResponseError);
    var status = err.status;
    var body = err.text;
    var url = err.url;
    var message = 'Request returned with status ' + status + ' and text ' + body + ' for url ' + url;
    var _this = (0, _possibleConstructorReturn3.default)(this, (ResponseError.__proto__ || Object.getPrototypeOf(ResponseError)).call(this, message));
    _this.status = status;
    _this.body = body;
    _this.message = message;
    _this.response = err.response;
    _this.url = err.url;
    return _this;
  }
  return ResponseError;
}(_ExtensibleError3.default);
exports.default = ResponseError;